<template>
  <v-chart @click="onClick" v-if="sunburst" :options="sunburst" />
</template>

<script>
import { createAkomando } from 'akomando';
import moment from 'moment';
import S from 'string';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/sunburst';
import 'echarts/lib/component/polar';


export default {
  /* eslint-disable prefer-rest-params */

  name: 'chart-giurisprudenza',
  props: ['aknString'],
  components: {
    'v-chart': ECharts,
  },
  beforeMount() {
    // create the akomando object
    const akomando = createAkomando({
      aknString: this.aknString,
    });
    this.akomando = akomando;

    // create the HTML dom
    const aknDom = this.akomando.getAkomaNtoso({});
    const refs = aknDom.getElementsByTagName('ref');
    const refsInfo = [];
    for (let i = 0; i < refs.length; i += 1) {
      const href = refs[i].getAttribute('href');
      let docType = S(href.split('/')[4]).humanize().s;
      if (docType === 'Sentenza' || docType === 'Ordinanza') {
        docType = docType.split(' ').join('\n');
        let docTypeInResult = _.find(refsInfo, { name: docType });
        if (!docTypeInResult) {
          refsInfo.push({
            name: docType,
            orderValue: href.split('/')[4],
            itemStyle: {
              color: (docType === 'Sentenza') ? '#133A3A' : '#638490',
            },
            children: [],
          });
        }
        docTypeInResult = _.find(refsInfo, { name: docType });

        const docYear = (() => {
          const docDate = href.split('/')[6];
          if (docDate.includes('-')) {
            return docDate.split('-')[0];
          }
          return docDate;
        })();
        const docNumber = href.split('/')[7];

        const docName = (() => {
          if (docType.toLowerCase() !== 'costituzione') {
            return `n° ${href.split('/')[7]} \n del ${href.split('/')[6]}`;
          } else if (href.includes('#')) {
            return S(href.split('#')[1]).humanize().s;
          }
          return '';
        })();
        if (docName !== '' && !_.find(docTypeInResult.children, { name: docName })) {
          docTypeInResult.children.push({
            name: docName,
            orderValue: (docType.toLowerCase() !== 'costituzione') ? moment(href.split('/')[6]).unix() : Number(href.split('#')[1].split('_')[1]),
            itemStyle: {
              color: (docType === 'Sentenza') ? '#133A3A' : '#638490',
            },
            docType: href.split('/')[4],
            docYear,
            docNumber,
            value: 1,
          });
        }
      }
    }
    const orderedRefs = _.chain(refsInfo).orderBy(['orderValue'], ['asc']).value();
    orderedRefs.map((o) => {
      // eslint-disable-next-line no-param-reassign
      o.children = _.orderBy(o.children, ['orderValue'], ['asc']);
      return o;
    });

    this.sunburst = {
      title: {
        text: 'Grafico dei riferimenti',
        textStyle: {
          fontSize: 14,
          align: 'center',
        },
        subtextStyle: {
          align: 'center',
        },
      },
      series: {
        type: 'sunburst',
        highlightPolicy: 'ancestor',
        data: orderedRefs,
        radius: [0, '95%'],
        sort: null,
        levels: [{
          r0: '15%',
          r: '35%',
          itemStyle: {
            borderWidth: 2,
          },
          label: {
            rotate: 'tangential',
          },
        }, {
          r0: '35%',
          r: '70%',
          label: {
            align: 'right',
          },
        }, {
          r0: '70%',
          r: '72%',
          label: {
            position: 'outside',
            silent: false,
          },
          itemStyle: {
            borderWidth: 3,
          },
        }],
      },
    };
  },
  async mounted() {
    /* const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
    const url = `${Vue.prototype.$proxy}getDocumentInfo.xq${separator}
    uri=${this.docUri}&year=${this.year}&number=${this.number}`;
    const documentInfo = await Vue.axios.get(url);
    this.documentInfo = documentInfo.data; */
  },
  methods: {
    onClick() {
      if (arguments[0].data &&
        arguments[0].data.docYear &&
        arguments[0].data.docNumber &&
        arguments[0].data.docType) {
        const path = `/pronuncia/${arguments[0].data.docType}/${arguments[0].data.docYear}/${arguments[0].data.docNumber}`;
        this.$router.push({
          path,
        });
        // eslint-disable-next-line no-undef
        $('#modal-document-info').modal('hide');
      }
    },
  },
  data() {
    return {
      documentInfo: null,
      sunburst: null,
    };
  },
};
</script>

<style scoped>
.echarts {
  position: relative;
  top:-20px!important;
  left:-100px!important;
  width: 620px!important;
  height: 530px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/ChartGiurisprudenza.vue